export const LINZ_KEY = process.env.REACT_APP_LINZ_KEY
export const MAPBOX_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN
export const LINZ_BASE_MAP_URL = 'https://basemaps.linz.govt.nz/v1/tiles/aerial/3857/{z}/{x}/{y}.png'
export const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID
export const DEFAULT_LAYER_OPTIONS = { maxZoom: 26, minZoom: 2, tileSize: 512, zoomOffset: -1 }
